
const initHeroText = () => {
  function scaleTextToFit(el, minFontSize = 20, maxFontSize = 300) {
    const container = el.parentElement;
    const containerWidth = container.clientWidth;

    let fontSize = maxFontSize;
    el.style.fontSize = fontSize + 'px';

    // Reduce font size until it fits or hits minimum
    while (el.scrollWidth > containerWidth && fontSize > minFontSize) {
      fontSize -= 1;
      el.style.fontSize = fontSize + 'px';
    }

    // Avoid too small text
    if (fontSize < minFontSize) {
      el.style.fontSize = minFontSize + 'px';
    }

    el.style.opacity = .1;
  }

  function applyScalingToAll() {
    const textEls = document.querySelectorAll('.hero--level-4 .background-text p');
    const textElsOffice = document.querySelectorAll('.post-library__background-text .background-font');
    textEls.forEach(el => scaleTextToFit(el));
    textElsOffice.forEach(el => scaleTextToFit(el));  
  }

  // Run once on load
  window.addEventListener('load', applyScalingToAll);

  // Run again on resize
  window.addEventListener('resize', applyScalingToAll);
};

export default initHeroText;
